module.exports = __webpack_public_path__ + "static/media/hall-PB.3b732b6c.svg";